<template>
  <svg
    id="Path_2_Copy"
    data-name="Path 2 Copy"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 8.615 5.743"
  >
    <path id="Path_2_Copy-2" data-name="Path 2 Copy" d="M4.307,5.743,0,0H8.615Z" fill="#bdbec2" />
  </svg>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '13.563',
    },
    width: {
      type: String,
      default: '13.56',
    },
    color: {
      type: String,
      default: 'label-text',
    },
  },
  computed: {
    /**
     * Icon Style
     * @param {void}
     * @returns {string} - Color
     * @description Assigns the specific color to the icon
     */
    iconStyle: function () {
      return {
        fill: ['$' + this.color, `var(--${this.color})`],
      }
    },
  },
}
</script>
